import { fetchComments } from 'actions/envelopeActions';
import { fetchNotifications } from 'actions/notifications';
import CommentsList from 'components/CommentsList';
import NotificationsList from 'components/NotificationsList';
import { RouteSpec, SuperRouteSpec } from 'types';

const notificationsRoutes: (RouteSpec | SuperRouteSpec)[] = [
  {
    name: 'notifications',
    path: '/:customerDomain/notifications',
    component: NotificationsList,
    private: true,
    permissions: 'notifications.list',
    data: {
      actions: [fetchNotifications],
      params: {
        order_by: {
          defaultValue: 'created_at',
        },
        order_desc: {
          defaultValue: 'true',
        },
        include_pii: {
          defaultValue: 'true',
        },
        include_count: {
          defaultValue: '1',
        },
        notifications: {
          nestedResource: true,
          params: {
            broad_search: {},
            limit: {
              defaultValue: '25',
            },
            offset: {
              defaultValue: '0',
            },
            order_by: {
              defaultValue: 'created_at',
            },
            order_desc: {
              defaultValue: 'true',
            },
            include_pii: {
              defaultValue: 'true',
            },
            include_count: {
              defaultValue: '1',
            },
          },
        },
      },
    },
  },
  {
    name: 'comments',
    path: '/:customerDomain/comments',
    component: CommentsList,
    private: true,
    permissions: 'notifications.list',
    data: {
      actions: [fetchComments],
      params: {
        order_by: {
          defaultValue: 'created_at',
        },
        order_desc: {
          defaultValue: 'true',
        },
        include_pii: {
          defaultValue: 'true',
        },
        include_count: {
          defaultValue: '1',
        },
        comments: {
          nestedResource: true,
          params: {
            broad_search: {},
            comment_type: {},
            limit: {
              defaultValue: '25',
            },
            offset: {
              defaultValue: '0',
            },
            order_by: {
              defaultValue: 'created_at',
            },
            order_desc: {
              defaultValue: 'true',
            },
            include_pii: {
              defaultValue: 'true',
            },
            include_count: {
              defaultValue: '1',
            },
          },
        },
      },
    },
  },
];

export default notificationsRoutes;
